import { useState, useEffect, useRef } from 'react'
import { useLocation, Link, useNavigate } from 'react-router-dom'
import styles from './LeadCaptureSetting.module.css'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

const LeadCaptureSetting = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
                leadCaptureId: passedState.leadCaptureId,
                leadCaptureName: passedState.leadCaptureName,
            }
            clientEventInfoRef.current = passedData
        }

    }
    useEffect(() => {
        const interval = setInterval(() => checkClientEvent(), (300)) // run events fetch every .3 seconds
        return () => clearInterval(interval)
    }, [])
    const checkClientEvent = () => {
        // Update clientevent with every render when its value has changed.
        let savedClientEvent = clientEventService.getClientEvent()
        if (clientEventInfoRef.current && clientEventInfoRef.current.leadCaptureId !== undefined &&
            savedClientEvent && savedClientEvent.leadCaptureId !== undefined &&
            savedClientEvent.leadCaptureId !== clientEventInfoRef.current.leadCaptureId) {
            setClientEventInfo(savedClientEvent)
            clientEventInfoRef.current = savedClientEvent;
        }
    }
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
                leadCaptureId: passedState.leadCaptureId,
                leadCaptureName: passedState.leadCaptureName,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>Lead Capture Management</h1><br />

            <div id={styles.eventConfigureContainer}>
                <Link to={`/ExhibitorList`} state={clientEventInfo} className={styles.eventLinks} title="Exhibitor Setup/Mobile App Setup here.">
                    <h3>Manage Exhibitors</h3>
                </Link>
                <Link to={`/LicenseManager`} state={clientEventInfo} className={styles.eventLinks} title="Mobile App license management.">
                    <h3>Manage LR App Licenses</h3>
                </Link>
                <Link to={`/elmah`} state={clientEventInfo} className={styles.eventLinks} title="Mobile App license management.">
                    <h3>Manage SAS App Licenses</h3>
                </Link>
                <Link to={`/elmah`} state={clientEventInfo} className={styles.eventLinks} title="Download show report, all exhibitors.">
                    <h3>Download Show Report</h3>
                </Link>
                <Link to={`/elmah`} state={clientEventInfo} className={styles.eventLinks} title="View trending financial reports.">
                    <h3>View Financial Reports</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button> 
        </div>
    );
}

export default LeadCaptureSetting;